// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3vqVT","footerRight":"styles_footerRight__15S6s"};